import styled, { css } from "styled-components";

const checkboxFieldStyles = css`
  .checkboxField {
    border-radius: 2px;
    opacity: 1;
    padding: 12px 10px;
    background-color: transparent;
    box-shadow: inset 0 0 0 0 transparent;
    transition: background-color 0.45s ease, box-shadow 0.45s ease;

    label {
      display: flex;
      align-items: center;
      gap: 7px;
      opacity: 1;
      color: rgba(115, 128, 137, 1);
      font-family: "SatoshiRegular";
      font-size: 16px;
      font-weight: 400;
      font-style: Regular;
      letter-spacing: 0;
      text-align: left;
      line-height: 24px;
      transition: color 0.45s ease;
    }

    input[type="checkbox"]:checked + label {
      color: #fff !important;
    }

    input[type="checkbox"] {
      appearance: none;
      background-color: transparent;
      margin: 0;
      font: inherit;
      width: 16px;
      height: 16px;
      border: 1px solid ${(props) => props.theme.green};
      border-radius: 2px;
      transform: translateY(-0.075em);
      display: grid;
      place-content: center;
      cursor: pointer;
    }

    input[type="checkbox"]::before {
      content: "";
      width: 8px;
      height: 0.6em;
      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 21%, 80% 0, 43% 62%);
      transform: scale(0);
      transition: transform 0.15s ease-in-out;
      background-color: ${(props) => props.theme.green};
    }

    input[type="checkbox"]:checked::before {
      transform: scale(1);
    }
  }

  .checkboxField.is-highlighted {
    background-color: ${(props) => props.theme.green}22;
    box-shadow: inset 0 0 0 2px ${(props) => props.theme.green};
    /* One-time entrance pop; steady glow is held afterwards so it can
       transition out smoothly (no snap) when the class is removed. */
    animation: paramHighlightIn 0.5s ease;

    label {
      color: ${(props) => props.theme.green} !important;
    }
  }

  @keyframes paramHighlightIn {
    0% {
      background-color: transparent;
      box-shadow: inset 0 0 0 0 ${(props) => props.theme.green};
    }
    55% {
      background-color: ${(props) => props.theme.green}44;
      box-shadow: inset 0 0 0 3px ${(props) => props.theme.green};
    }
    100% {
      background-color: ${(props) => props.theme.green}22;
      box-shadow: inset 0 0 0 2px ${(props) => props.theme.green};
    }
  }
`;

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.6" : "1")};
`;

export const DropdownButton = styled.div`
  background: transparent;
  border: none;
  border-bottom: 1px solid
    ${(props) => (props.error ? props.theme.red : props.theme.blueish2)};
  outline: none;
  opacity: 1;
  color: ${(props) => props.theme.blueish};
  font-family: "SatoshiRegular";
  font-size: 14px;
  font-weight: 400;
  font-style: Regular;
  letter-spacing: 0;
  text-align: left;
  line-height: 24px;
  padding-left: 5px;
  padding-bottom: 4px;

  &:placeholder {
    opacity: 1;
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiRegular";
    font-size: 14px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
  }

  &:disabled {
    color: ${(props) => props.theme.blueish2} !important;
  }

  img {
    position: absolute;
    right: 0;
    bottom: 5px;
    cursor: pointer;
  }
`;

export const DropdownContent = styled.div`
    display: ${(props) => (props.$show ? "block" : "none")};
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 99999;
    min-width: 100%;
    max-width: 320px;

    border-radius: 4px;
    background: ${(props) => props.theme.black};
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid ${(props) => props.theme.borderColor};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);

    > div {
        opacity: 1;
        color: ${(props) => props.theme.blueish};
        font-family: "SatoshiRegular";
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        text-align: left;
        line-height: 24px;
        padding: 10px 6px;
        cursor: pointer;

        &:hover {
            background-color: ${(props) => props.theme.black};
        }
    }
`;

export const DropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  background-color: ${(props) =>
    props.selected ? props.theme.green : props.theme.lines};
  color: ${(props) =>
    props.selected ? props.theme.black : props.theme.white} !important;

  &:hover {
    background-color: #ddd;
    color: ${(props) => props.theme.white} !important;
  }
`;

export const MatchCheckbox = styled.input`
  appearance: none;
  background-color: transparent;
  margin: 0;
  font: inherit;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  pointer-events: none;
  border: 1px solid ${(props) => props.theme.green};
  border-radius: 2px;
  display: grid;
  place-content: center;

  &::before {
    content: "";
    width: 8px;
    height: 0.6em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 21%, 80% 0, 43% 62%);
    transform: scale(0);
    transition: transform 0.15s ease-in-out;
    background-color: ${(props) => props.theme.black};
  }

  &:checked {
    border-color: ${(props) => props.theme.black};
  }

  &:checked::before {
    transform: scale(1);
  }
`;

export const MatchDropdownItem = styled(DropdownItem)`
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover ${MatchCheckbox}:checked {
    border-color: ${(props) => props.theme.green};
  }

  &:hover ${MatchCheckbox}:checked::before {
    background-color: ${(props) => props.theme.green};
  }
`;

export const EventCardWrapper = styled.div`
  h3 {
    opacity: 1;
    color: ${(props) => props.theme.blueish2};
    font-family: "SatoshiRegular";
    font-size: 12px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0;
    text-align: left;
    line-height: 18px;
    padding-left: 30px;
    margin-bottom: 7px;
  }
`;

export const EventCard = styled.div`
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.borderColor};
  box-shadow: 3px 2px 30px rgba(68, 68, 68, 0.12);
  opacity: 1;
  background-color: ${(props) => props.theme.sidebar};
`;

export const EventTabsCard = styled(EventCard)`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  height: ${(props) => (props.$nested ? "400px" : "auto")};
  overflow: hidden;
  border: ${(props) => (props.$nested ? "none" : undefined)};
  box-shadow: ${(props) => (props.$nested ? "none" : undefined)};
  background-color: ${(props) => (props.$nested ? "transparent" : undefined)};
  border-radius: ${(props) => (props.$nested ? "0" : undefined)};
`;

export const EventContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  ${checkboxFieldStyles}
`;

export const ParametersTabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EventTabsHeader = styled.div`
  flex-shrink: 0;
  padding: 20px 20px 12px;
`;

export const ParameterSearchInput = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.blueish2};
  outline: none;
  color: ${(props) => props.theme.blueish};
  font-family: "SatoshiRegular";
  font-size: 14px;
  padding: 6px 5px;
  margin: 0 20px 4px;
  width: calc(100% - 40px);

  &::placeholder {
    color: ${(props) => props.theme.blueish2};
  }

  &:focus {
    border-bottom-color: ${(props) => props.theme.green};
  }
`;

export const EventTabsScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 20px 20px;
  ${checkboxFieldStyles}
`;

export const FootballFielOptions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 0;
  margin-bottom: 10px;
`;

export const DirectionStatus = styled.div`
  margin-bottom: 10px;

  label {
    display: flex;
    align-items: center;
    gap: 5px;

    color: ${(props) => props.theme.white};
    font-family: "SatoshiMedium";
    font-size: 16px;
    font-weight: 500;
    font-style: Medium;
  }
`;

export const OwnOpponnentSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.lines};
  padding: 4px;
  border-radius: 2px;

  .tabItem {
    width: 50%;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "SatoshiRegular";
    font-size: 16px;
    color: ${(props) => props.theme.blueish2};
    cursor: pointer;
    text-transform: capitalize;
  }

  .tabItem.active {
    background-color: ${(props) => props.theme.blueish3};
    color: ${(props) => props.theme.green};
    border-radius: 2px;
    font-family: "SatoshiBold";
  }
`;
